module.exports = __webpack_public_path__ + "static/media/all.81e499e0.pred";